import { actionTypes } from "./constants";

export const initialState = {
    data: null,   
    previousRequestSource: null,
    fetching: false,
}

export const browserProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_BROWSER_PROFILE_DATA:
            return {
                ...state,
                data: action.payload
            }
        case actionTypes.SET_BROWSER_PROFILE_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_BROWSER_PROFILE_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 